import script from "./FamousDoctorClass.vue?vue&type=script&setup=true&lang=js"
export * from "./FamousDoctorClass.vue?vue&type=script&setup=true&lang=js"

import "./FamousDoctorClass.vue?vue&type=style&index=0&id=4650e014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4650e014"]])

export default __exports__